/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RefreshTokenVm,
    RefreshTokenVmFromJSON,
    RefreshTokenVmFromJSONTyped,
    RefreshTokenVmToJSON,
    UserInfoVm,
    UserInfoVmFromJSON,
    UserInfoVmFromJSONTyped,
    UserInfoVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface LoginVm
 */
export interface LoginVm {
    /**
     * 
     * @type {UserInfoVm}
     * @memberof LoginVm
     */
    userInfo?: UserInfoVm;
    /**
     * 
     * @type {string}
     * @memberof LoginVm
     */
    accessToken?: string | null;
    /**
     * 
     * @type {RefreshTokenVm}
     * @memberof LoginVm
     */
    refreshToken?: RefreshTokenVm;
}

export function LoginVmFromJSON(json: any): LoginVm {
    return LoginVmFromJSONTyped(json, false);
}

export function LoginVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userInfo': !exists(json, 'userInfo') ? undefined : UserInfoVmFromJSON(json['userInfo']),
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : RefreshTokenVmFromJSON(json['refreshToken']),
    };
}

export function LoginVmToJSON(value?: LoginVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userInfo': UserInfoVmToJSON(value.userInfo),
        'accessToken': value.accessToken,
        'refreshToken': RefreshTokenVmToJSON(value.refreshToken),
    };
}


